/* eslint-disable max-lines */
/* eslint-disable max-len */

export default {
    name: 'GdprData',

    /**
     * @override
     */
    data() {
        return {
            edit: false,
            originalIntervener: null,
            modifiedIntervener: [],
            intervenerEdit: {},
            dayStr: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
            booleanOptions: [
                { key: true, name: this.$t(`general.yes`) },
                { key: false, name: this.$t(`general.no`) }
            ],
            tableFields: [
                { key: 'status', label: this.$t(`headers.status`), class: 'status' },
                { key: 'updated_on', label: this.$t('headers.last_update'), class: 'updated_on' },
                { key: 'key_name', label: this.$t('headers.comunication'), class: 'key_name' }
            ],
            popperProps: {
                arrowOffsetScaling: 0,
                popperOptions: {
                    modifiers: {
                        preventOverflow: {
                            padding: 20
                        }
                    }
                }
            }
        };
    },
    props: {
        uuidIntervener: {
            type: String,
            required: false
        },
        intervenerData: {
            type: Array,
            required: true
        }

    },
    watch: {
        intervenerData: {
            immediate: true,
            deep: true,
            handler(newVal) {
                const editMap = {};
                newVal.forEach(item => {
                    const matchedOption = this.booleanOptions.find(opt => opt.key === item.status);
                    editMap[item.uuid] = {
                        status: matchedOption,
                        updated_on: item.updated_on
                    };
                });
                this.intervenerEdit = editMap;
            }
        }
    },
    methods: {
        /**
         * @param {Boolean} edit allow edit or not
         * @param {Event} e Evento del form
         */
        setEdit(edit, e) {
            e.preventDefault();
            e.stopPropagation();
            this.edit = edit;
            if (!edit) {
                this.originalIntervener = Object.assign({}, this.intervenerData);
            }
        },
        /**
         * @param {Event} e FormEvent
         */
        async onSubmit(e) {
            e.preventDefault();

            const promises = [];

            for (const uuid in this.modifiedIntervener) {
                const edited = this.modifiedIntervener[uuid];
                const original = this.intervenerData.find(i => i.uuid === uuid);
                
                if (!original) continue;

                const field = this.$t(`accounts.gdpr.${original.key_name}`);
                
                const payload = {
                    [field]: edited.status,
                    source: 'BACK_OFFICE'
                };
                
                const promise = this.$intervenersService.updateIntervenerGDPR(this.uuidIntervener, payload);
                promises.push(promise);
                
                const updateIntervener = this.$intervenersService.updateIntervenerInfo(this.uuidIntervener, { has_done_gdpr: true })
                promises.push(updateIntervener);
            }

            try {
                const res = await Promise.all(promises);
                this.edit = false;
                this.modifiedIntervener = {};
                this.$toast.success('Datos actualizados', 'Sus preferencias de privacidad se han guardado correctamente.');
                this.$emit('saved', res.map(r => r.data.intervener_gdpr));
            } catch (err) {
                this.$toast.error('Error', 'No se pudieron guardar los cambios');
                this.edit = false;
                this.modifiedIntervener = {};
            }
        },
        /**
         * @param {String} val value of input
         * @param {String} key key to update
         */
        setGDPRRowDate(val, key) {
            if (!val) {
                return;
            }
            this.intervenerEdit[key]['updated_on'] = val;
            if (!this.modifiedIntervener[key]) {
                this.modifiedIntervener[key] = {};
            }
            this.modifiedIntervener[key]['updated_on'] = val;
        },
        /**
         * @param {String} val value of input
         * @param {String} key key to update
         */
        onSelectGPRDStatus(option, uuid) {
            this.intervenerEdit[uuid].status = option;

            if (!this.modifiedIntervener[uuid]) {
                this.modifiedIntervener[uuid] = {};
            }

            this.modifiedIntervener[uuid].status = option.key;
        }
    }
};
